import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Download, SubtoolOutputDetails } from 'src/app/models/tool.model';
import { ToastService, ToolService } from 'src/app/services';
import { FileSaverService } from 'ngx-filesaver';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';

interface SelectedSubtoolDetailsItem {
  name: string;
  type: string;
  value: string;
  id: string;
}

@Component({
    selector: 'app-export-modal',
    templateUrl: './export-modal.component.html',
    styleUrls: ['./export-modal.component.scss'],
    standalone: false
})
export class ExportModalComponent implements OnInit {

  @Input() idExecution: string;
  @Input() currentTool: string;
  @Input() typeExport: string;
  @Input() isOPV?: boolean=false;
  // tslint:disable-next-line: no-output-native
  @Output() submit: EventEmitter<any> = new EventEmitter();

  exportForm: UntypedFormGroup;
  submitted = false;
  isAllSelected = false;
  itemsList: string[];
  selectedItem: string[];
  selectedSubtoolDetails: SubtoolOutputDetails[];
  selectedSubtoolDetailsFiltered: SubtoolOutputDetails[];
  activeIndexTab: number;
  finalArray = [];
  title: string;
  subtitle: string;
  inputTitle: string;
  hasLoadedAllControls:boolean = false;
  selectedScenarios: Map<number,string> = new Map<number, string>();
  fileName: string = "";
  fileUrl:string  = "";
  file: Blob;
  loader = false;
  downloadProgress: Download;
  selectedSubtoolDetailsItems: SelectedSubtoolDetailsItem[] = [];


  public id_export : any


  states = ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia',
  'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
  'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana',
  'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia',
  'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];


  @ViewChild('input') inputEl;
  selectedItems = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private toolService: ToolService,
    private fileSaverService: FileSaverService
  ) { }

  async ngOnInit() {

     // console.log(this.isOPV);
    this.exportForm = this.formBuilder.group({
      item: [[], [Validators.required]]
    });

    this.exportForm.get('item').valueChanges.subscribe((value) => {
      this.isAllSelected = value.length === this.itemsList.length;
    });
    
    if(this.isOPV==true){
      this.exportForm = this.formBuilder.group({
        item: [['All'], [Validators.required]]
      });
      this.title = 'Download outputs';
          this.subtitle= 'Press to download the Navigators data' ;
          this.inputTitle = 'Subtool';
          this.hasLoadedAllControls = true;
    }else{
    
    switch(this.typeExport)
    {
      case 'Input':
         this.title = 'Download input files';
         this.subtitle= 'Select one or more sets of input files you want to download.' ;
         this.inputTitle = 'Sets of input files';
         this.hasLoadedAllControls = true;
         try 
          {
            this.itemsList = (await this.toolService.getAvailableInputFiles(this.idExecution));
          } catch (error) {
              this.toastService.showError(error);
              console.error('error =>', error);
          }
        break;
        case 'Output':
          this.title = 'Download outputs';
          this.subtitle= 'Select one or more subtool you want to export.' ;
          this.inputTitle = 'Subtool';
          this.hasLoadedAllControls = true;
          try 
          {
            this.itemsList = (await this.toolService.getAvailableOutputSubtools(this.idExecution)).availableSubtools;
          } catch (error) {
              this.toastService.showError(error);
              console.error('error =>', error);
          }
        break;
        case 'Custom report':
          this.title = 'Download custom report';
          this.subtitle= 'Select one or more custom reports you want to export' ;
          this.inputTitle = 'Custom report';
          this.itemsList = (await this.toolService.getAvailableCustomReportFiles(this.idExecution));
          this.hasLoadedAllControls = true;
          break;

    }  

    // console.log(this.hasLoadedAllControls);
    // console.log(this.exportForm);

    
  }
  }

  /**
   * Get form
   */

  get export() { return this.exportForm.controls; }

  onSelectAll() {
    this.isAllSelected = !this.isAllSelected;
    this.selectedItem = this.itemsList.map(item => item);
    this.exportForm.get('item').patchValue(this.isAllSelected ? this.selectedItem : []);
  }


  async onCloseSelect() {
    try {
      /**
       * when I open the subtool select the second time
       * and decrease the length of the selected values,
       * the fields of the form are reset
       */
      if(this.isOPV==true)return;

      if (this.typeExport.toLowerCase() === 'output' && this.exportForm.value.item.length >= 0) {
        this.hasLoadedAllControls = false;
        
      /**
       * Open the subtool select for the first time
       * and initialize the form fields
       */
    
      this.selectedSubtoolDetails =
      await this.toolService.getAvailableOutputSubtoolsDetails(this.idExecution, this.exportForm.value.item);
      this.activeIndexTab = 0;
      this.selectedSubtoolDetails.map((element, index) => {
        this.addNewSelectedItem(element.name, "view", undefined, "view" + index);
        this.addNewSelectedItem(element.name, "isin", undefined, "isin" + index);
        this.addNewSelectedItem(element.name, "scenario", undefined, "scenario" + index);
    
      });

      this.selectedSubtoolDetailsFiltered = this.selectedSubtoolDetails.filter(x => x.views !== null || x.isins !== null);

      this.selectedSubtoolDetailsFiltered.map((_, index) => {

        if (this.selectedSubtoolDetailsFiltered[index].views) {
          let selectedViews = this.selectedSubtoolDetailsItems.filter(x => x.name === _.name && x.type === "view");
          let selectedViewValue = selectedViews.length == 1 ? selectedViews[0].value : undefined;
          let selectedViewId =  selectedViews[0].id;
          this.exportForm.addControl(`${selectedViewId}`, new UntypedFormControl(null, [Validators.required]));
          if(selectedViewValue !== undefined){
            this.exportForm.get(selectedViewId).patchValue(selectedViewValue);
          }

        }

        if (this.selectedSubtoolDetailsFiltered[index].isins) {
          let selectedIsins = this.selectedSubtoolDetailsItems.filter(x => x.name === _.name && x.type === "isin");
          let selectedIsinValue = selectedIsins.length == 1 ? selectedIsins[0].value : undefined;
          let selectedIsinId =  selectedIsins[0].id;
          this.exportForm.addControl(`${selectedIsinId}`, new UntypedFormControl(null, [Validators.required]));
          if(selectedIsinValue !== undefined){
           this.exportForm.get(selectedIsinId).patchValue(selectedIsinValue);
          }
        }
        if (this.selectedSubtoolDetailsFiltered[index].scenarios?.length == 0){
          this.getSelectedValue(_.name, false);
        }
      });
        
        if (this.selectedSubtoolDetails && this.exportForm.value.item.length < this.selectedSubtoolDetails?.length) {

          this.selectedSubtoolDetailsFiltered.map((_, index) => {

            let selectedViewId = this.getDetailId(_.name, "view");
            if (this.exportForm.get(selectedViewId)) {  
              const view = this.exportForm.get(selectedViewId);
              this.addNewSelectedItem(_.name, "view", view.value, selectedViewId);
              this.exportForm.removeControl(`${selectedViewId}`);
            }

            let selectedIsinId = this.getDetailId(_.name, "isin");
            if (this.exportForm.get(selectedIsinId)) {
              const isin = this.exportForm.get(selectedIsinId);     
              this.addNewSelectedItem(_.name, "isin", isin.value, selectedIsinId);
              this.exportForm.removeControl(`${selectedIsinId}`);
            }
          });
        }

        this.exportForm.updateValueAndValidity();
        this.hasLoadedAllControls = true;
      } else {
        this.selectedSubtoolDetails = [];
      }
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Intercepts the value selected for the viewBy
   * and if there are scenarios it initializes the form field
   * with the scenarios returned by the API
   * @param tabIndex Current tab index
   */

  async getSelectedValue(name: string, scenarioExist: boolean = true) {
    let selectedViewId = this.getDetailId(name, "view");
    let selectedScenarioId = this.getDetailId(name, "scenario");
    if(this.exportForm.value[`${selectedScenarioId}`] && scenarioExist) {
      this.exportForm.removeControl(`${selectedScenarioId}`);
    }

    try {
      this.selectedSubtoolDetailsFiltered.filter(x => x.name === name)[0].scenarios = (await this.toolService.getAvailableOutputSubtoolAggregationScenarios(
        this.idExecution,
        name,
        this.exportForm.value[`${selectedViewId}`]
      )).scenarios;
      if (this.selectedSubtoolDetailsFiltered.filter(x => x.name === name)[0].scenarios?.length > 0) {
        this.exportForm.addControl(`${selectedScenarioId}`, new UntypedFormControl(null, [Validators.required]));
      }

    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
    
  }

  /**
   * To call the API which filters the isins when the user writes to the input
   * @param text$ Entered value
   */

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        const matchRegExp = new RegExp(term, 'gi');
        return term.length === 0 ? [] : this.states.filter(v => {
          return this.selectedItems.indexOf(v) === -1 && matchRegExp.test(v);
        });
      })
    )

    /**
     * Intercept the selected typeahead value
     * @param event Selected object
     * @param index Current tab index
     */

  selected(event: NgbTypeaheadSelectItemEvent, index: number) {
    event.preventDefault();
    const isins = this.exportForm.get('isin' + index);
    isins.value.push(event.item);
    isins.updateValueAndValidity();
    this.inputEl.nativeElement.value = '';
  }

  /**
   * Intercept the removed typeahead value
   * @param item Removed item
   * @param index Current tab index
   */

  close(item: string, index: number) {
    const isins = this.exportForm.get('isin' + index);
    isins.value.splice(isins.value.indexOf(item), 1);
    isins.updateValueAndValidity();
    this.inputEl.nativeElement.focus();
  }

  
  /**
   * Submit of the modal,
   * creates the object to be sent to the API for exporting files
   */

  async onSubmit() {
    //TO DO gestire index e id per views, isins e scenarios
    // console.log('Submit')

    this.finalArray = [];
    try {
      window.setTimeout(() => { this.loader = true;}, 2000);
      this.downloadProgress = {
      state: 'PENDING',
      progress: 0,
      content: null,
      title: 'File generation in progress'
    };
    if(this.isOPV==true){
      
      this.toolService.getOutputFilesOPV(null).subscribe(
        event => this.progressDownload(event),
        error => {
          this.closeModal();
          this.toastService.showError(error);
          console.error('error =>', error);
        }
      );
    }

    switch(this.typeExport){
      case 'Input':
        this.toolService.getInputFiles(this.idExecution, this.exportForm.value.item).subscribe(
          event => this.progressDownload(event),
          error => {
            this.closeModal();
            this.toastService.showError(error);
            console.error('error =>', error);
          }
          );
                        
        

        break;
      case 'Output':
        this.selectedSubtoolDetails.map((subtool, index) => {
          let selectedViewId = this.getDetailId(subtool.name, "view");
          let selectedIsinId = this.getDetailId(subtool.name, "isin");
          let selectedScenarioId = this.getDetailId(subtool.name, "scenario");

          const indexView = subtool.views?.findIndex(view => view.value === this.exportForm.value[selectedViewId]);
          const indexScenario = subtool.scenarios?.findIndex(scenario => scenario.value === this.exportForm.value[selectedScenarioId]);
          const indexIsins = subtool.isins?.findIndex(isin => isin === this.exportForm.value[selectedIsinId]);
          this.finalArray[index] = {
            name: subtool.name,
            views: subtool.views ? subtool.views[indexView] : null,
            scenarios: subtool.scenarios ? subtool.scenarios[indexScenario] : null,
            isins: subtool.isins ? subtool.isins[indexIsins] : null
          };
         
        });

        this.toolService.getOutputFiles(this.idExecution, this.finalArray).subscribe(
          event => this.progressDownload(event),
          error => {
            this.closeModal();
            this.toastService.showError(error);
            console.error('error =>', error);
          }
        );
        // this.fileName = this.getFileName(outputResponse);
        // this.file = outputResponse.body;
        // this.fileUrl = await this.getFileUrl(outputResponse);
      
       break;
      case 'Custom report':
        this.toolService.getCustomReportFiles(this.idExecution, this.exportForm.value.item).subscribe(
            event => this.progressDownload(event),
            error => {
              this.closeModal();
              this.toastService.showError(error);
              console.error('error =>', error);
            }
          );        
        // this.fileName = this.getFileName(customResponse);
        // this.file = customResponse.body;
        // this.fileUrl = await this.getFileUrl(customResponse);
            
         break;
    }
    
    } catch (error) {
      this.closeModal();
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  downloadFile(event:HttpResponse<Blob>)
  {
    this.loader = false;
    this.activeModal.dismiss('Cross click');
    this.fileName = this.getFileName(event);
    this.file = event.body;
    this.fileSaverService.save(this.file, this.fileName);
  }


  progressDownload(event: HttpEvent<Blob>)
  {      
       if (event.type === HttpEventType.DownloadProgress) {
         const percentDone = Math.round(100 * event.loaded / event.total);         
          this.downloadProgress = {
            state: 'IN_PROGRESS',
            progress: percentDone,
            content: null,
            title: 'File downloading'
          }
       }
       if (event.type === HttpEventType.Response) {
         this.downloadProgress = {
           state: 'DONE',
           progress: 100,
           content: event.body,
           title: 'Completed'
         }
         this.downloadFile(event);
       }
       
  }

  getFileName(response:any) 
  {
      const content = response.headers.get("content-disposition");
      const matches = /filename=([^;]+)/ig.exec(content);
      return (matches[1] || 'untitled').trim();
  }

  closeModal()
  {
    this.loader = false;
    this.activeModal.dismiss('Cross click');
  }

  getFileUrl(response:any): Promise<string>
  {
    const reader = new FileReader();  
    return new Promise((resolve) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(response.body);

    });
  }

 addNewSelectedItem(name: string, type: string, value: string | undefined, id: string | undefined)
 {
   let selectedSubtoolDetailsItemFound = false;
    this.selectedSubtoolDetailsItems.filter(x => x.name === name && x.type == type).forEach(element =>{
      element.value = value;
      selectedSubtoolDetailsItemFound = true;
  });

  if(!selectedSubtoolDetailsItemFound){
    let selectedSubtoolDetailsItem: SelectedSubtoolDetailsItem = {name: name, type: type, id: id, value: value};
    this.selectedSubtoolDetailsItems.push(selectedSubtoolDetailsItem);
  }
 }

 getDetailId(name: string, type: string){
  let selectedViews = this.selectedSubtoolDetailsItems.filter(x => x.name === name && x.type === type);
  return selectedViews[0].id;
 }
}
